<template>
 <div id="default-layout">
      <Header @reloadPageId="changePageId" :rotaAtual="rotaAtual" @closePopup="closePopup" :popupObject="popupObject" @logout="logoutSite" :isLogged="logged"/>
      <div class="wrapper">
        <vue-page-transition name="fade">
        <router-view :isLogged="logged" :key="pageId"  @logout="logoutSite" @updateFaq='updateFaq' @changeActiveCard='newCardData' @openPopup="openPopup" @retrieveMyUser="retrieveMyUser" @userData="changeUserData" @login="loginSite" :class="logged ? 'container' : 'container'" :faqs="faqs" :userData="user" :privacy="privacy" :terms="terms"></router-view>
        </vue-page-transition>
      </div>
      <PopupMessage name="popup-geral" v-on:closePopup="() => { closeStoreModal() }" v-bind="modalAlert" :teste="modalAlert.teste" />
      <ModalCartaoDesassociado :open="cardDissociatedModal" />
      <Footer :terms="terms" :privacy="privacy"/>
      <div style="display:none;">RELEASE {{ VERSION }}</div>
  </div>
</template>
<style lang="scss">
  .wrapper {
    min-height: calc(100vh - 242px - 130px);
    @media(max-width: 725px) {
      min-height: calc(100vh - 180px);

    }
  }
</style>
<script>
  import { VERSION } from '../config/http';
  import Header from '../components/Header';
  import ModalCartaoDesassociado from '../components/ModalCartaoDesassociado';
  import PopupMessage from '../components/PopupMessage';
  import Footer from '../components/Footer';
  import {resolvePromise, objectBalanceWidth,removeToken, baseUrl} from '../helpers/helpers'
  import {getActivePrivacyPolicy} from '../services/privacy.service'
  import {getActiveTermsAndConditions} from '../services/terms.service'
  import {myUser} from '../services/user.service'
  import service from '../services/qrcode.service'
  import { types } from '../store';
  //import {get} from '../services/image.service'
  // import {logout} from '../services/login.service'
  export default {
    name: "Main",
    components: {
      Header,
      Footer,
      PopupMessage,
      ModalCartaoDesassociado
    },
    data(){
      return{
        VERSION: null,
        cardDissociatedModal: false,
        rotaAtual: null,
        logged:false,
        user:null,
        faqs:[],
        pageId:null,
        popupObject:{
          message:null,
          title:null,
          dialog:false
        },
        imagesObject:{},
        activeCard:null,
        terms:null,
        privacy:null
      }
    },
    watch:{
    $route ({name:atual}, {name:antigo}){
      this.rotaAtual = atual;
      console.log('main-route',antigo, atual);
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    modalAlert() {
      return this.$store.state.modal_alert || { message: null, title: null, dialog: false };
    }
  },
   mounted(){
     this.rotaAtual = this.$route.name;
     this.VERSION = VERSION;
      // if(!sessionStorage.getItem("giro-token")) {
      //   this.logged = false
      //   const
      //     name = this.$router.history.current.name,
      //     changeRoute = name !== "conta" && name !== "login" 
      //   if(changeRoute) redirect("login",this)
      // }
      if(!this.terms){
        resolvePromise(getActiveTermsAndConditions(),({data})=>this.terms = data,console.log,this)
      }
      if(!this.privacy){
        resolvePromise(getActivePrivacyPolicy(),({data})=>this.privacy = data,console.log,this)
      }
    document.addEventListener('click', function (event) {
        if(Array.from(event.target.classList).indexOf('v-select__selections') > -1 ){
          document.querySelector(".v-menu__content").style.display = "initial"      
        }
        if(Array.from(event.target.classList).indexOf('v-select__selections') === -1 && (document.querySelector(".v-menu__content") && !document.querySelector(".v-menu__content").hidden)){
          document.querySelector(".v-menu__content").style.display = "none"
        }   
    }, false);
    setTimeout(() => this.loadCookie(), 1000);
    this.loadEvento();
   },
   methods:{
    closeStoreModal() {
      this.$store.dispatch(types.MODAL_ALERT, null);
    },
    loadEvento() {
      if(!this.current) {
        service.getEventoAtivo().then(res => {
          let icone = `${ baseUrl }/getimages/${res.data.icone.path}`
          res.data.icone = icone;
          if(res.data.logoPatrocinio) {
            res.data.logoPatrocinio =  `${ baseUrl }${res.data.logoPatrocinio.imageUrl}`;
          }
          if(res.data.banner) {
            res.data.banner =  `${ baseUrl }${res.data.banner.imageUrl}`;
          }
          console.log(res.data);
          this.$store.dispatch(types.SET_QRCODE_CURRENT, res.data);
        }).catch((err) => console.error(err));
      }
    },
    loadCookie: function() {
      try {
        if(!document.querySelectorAll('script[src*="OtAutoBlock"]').length) {
          let recaptchaScript = document.createElement('script')
          recaptchaScript.setAttribute('src', 'https://cdn.cookielaw.org/consent/2e714f89-d0c4-497f-8061-6a1c8d5152c1/OtAutoBlock.js')
          document.head.appendChild(recaptchaScript);
        }
        if(!document.querySelectorAll('script[src*="otSDKStub"]').length) {
          let recaptchaScript2 = document.createElement('script')
          recaptchaScript2.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js')
          recaptchaScript2.setAttribute('data-document-language', 'true');
          recaptchaScript2.setAttribute('charset', 'UTF-8');
          recaptchaScript2.setAttribute('data-domain-script', '2e714f89-d0c4-497f-8061-6a1c8d5152c1');
          document.head.appendChild(recaptchaScript2);
        }
        if(!document.querySelectorAll('script[rel="run-OptanonWrapper"]').length) {
          let recaptchaScript3 = document.createElement('script')
          recaptchaScript3.setAttribute('rel', 'run-OptanonWrapper');
          recaptchaScript3.text = "console.log('OptanonWrapper');function OptanonWrapper() { }";                
          document.head.appendChild(recaptchaScript3);
        }
      } catch(err) { console.log(err); }
    },
     changeBalanceWidth({cardBalance,promoBalance,creditBalance}){
      let
        arrayBalance = []
      if(creditBalance >= 0) arrayBalance.push({creditBalance})
      if(promoBalance >= 0)  arrayBalance.push({promoBalance})
      if(cardBalance >= 0) arrayBalance.push({cardBalance})
      arrayBalance.forEach(balance => {
        let 
          valor= Object.values(balance)[0],
          key = Object.keys(balance)[0],
          tamanho = String(valor).length >= 3 ? String(valor).length : 3,
          baseSeletor = ".infoUser .extrato .",
          seletores = {creditBalance:"credito",cardBalance:"saldo",promoBalance:"promo"},
          newWidth = objectBalanceWidth[key].initial + (objectBalanceWidth.step * (tamanho - 3))
          
          document.querySelector(`${baseSeletor}${seletores[key]}`).style.width = `${newWidth}px` 
          
      });
     },
     logoutSucessful(data){
       console.log({data})
       removeToken()
      //  this.user = null
      //  window.giroEmail = null
       this.logged = false
     },
     setUser(data){
       this.user = data
       window.giroEmail = data.email
       if(this.activeCard) this.user.activeCard = this.activeCard
     },
     logoutSite(){
      //  resolvePromise(logout(),this.logoutSucessful,(err)=>this.openPopup({message:"Erro ao fazer o logout",title:"Erro",dialog:true}),this)
       window.giroEmail = null       
        removeToken()
       this._data = {
        logged:false,
        user:null,
        faqs:[],
        pageId:null,
        imagesObject:{},
        popupObject:{
          message:null,
          title:null,
          dialog:false
        },
        activeCard:null,
        terms:null,
        privacy:null
      }
     },
     loginSite(){
       this.logged = true
     },
     changeUserData(data){
       this.user = data
       window.giroEmail = data.email
       if(this.activeCard) this.user.activeCard = this.activeCard
     },
     updateFaq(data){
       data.forEach(faq=>{
        const
          hasCategory = this.faqs.find(e=>e.category === faq.category.title ),
          index = hasCategory ? this.faqs.indexOf(hasCategory) : -1
          console.log(index > -1)
          index > -1 ? this.faqs[index].questions.push(faq) : this.faqs.push({category:faq.category.title,questions:[faq]})          
       })
     },
     addImage({page,data}){
       console.log({page,data})
       this.imagesObject[page] = data
     },
     closePopup(){
       this.popupObject.dialog = false
     },
     openPopup(data){
      this.popupObject = { message:null, title:null, dialog:false }
      setTimeout(() => { this.popupObject = data }, 300);
     },
     newCardData(data){
      if(!this.user.activeCard) return

      let activeCard = this.user.activeCard
    
      if(window.innerWidth >= 1024) this.changeBalanceWidth(data)
      this.activeCard = {...activeCard,...data}
      this.user.activeCard = this.activeCard
       
     },
     changePageId(){
       this.pageId = Math.random(1).toFixed(1)
     },
     retrieveMyUser(){
       resolvePromise(myUser(),({data})=>this.setUser(data),(err) => {
         if(err == 'CARD-DISSOCIATED') {
          this.cardDissociatedModal = true;
          resolvePromise(myUser(),({data})=>this.setUser(data),(err) => console.log(err));
        }
       },this)
     },
      /*getImage(page){
        if(this.imagesObject[page]) return
        resolvePromise(get(page),({data})=>this.imagesObject[page] = data,console.log,this)
      }*/
   }
  }
</script>